import React, { Fragment, Component } from "react";
import styled, { css, keyframes } from "styled-components";

export const Segment = styled.section`
  width: 100%;
  height: 100vh;
`;

export const Stretched = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
`;

export const AbsoluteStretched = styled(Stretched)`
  position: absolute;
`;

export const Centered = styled(Stretched)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Logo = () => (
  <LogoStyle viewBox="0 0 60.658345 45.205913">
    <g transform="translate(-279.74 -521.67)">
      <path d="m299.68 565.39c-14.955-4.027-22.814-13.383-18.971-22.583 1.4278-3.4171 4.2314-6.8862 5.5413-6.8567 2.703 0.061 3.0684 1.778 1.1706 5.5002-2.385 4.6779-2.4775 6.6451-0.49312 10.482 3.2823 6.3473 11.166 10.019 23.491 10.942 6.0701 0.4542 7.553 0.89215 7.8233 2.3104 0.29219 1.5332-0.5117 1.7418-6.4898 1.6842-3.7528-0.0362-9.1855-0.7019-12.073-1.4793z" />
      <path d="m324.08 553.11c-5.5928-6.18 3.1586-14.492 10.122-9.6146 2.8019 1.9625 3.021 7.4107 0.39377 9.7883-2.4714 2.2366-8.4239 2.1382-10.516-0.17375z" />
      <path d="m302.46 546.47c-0.66679-0.80343-1.4562-3.2791-1.7543-5.5015-1.4365-10.71 12.346-19.301 30.965-19.301 8.5086 0 9.7537 0.47072 8.0973 3.0611-0.71893 1.1243-2.2344 1.6426-4.4646 1.5269-5.1678-0.26806-14.904 1.6487-19.007 3.7419-5.9654 3.0433-8.1729 6.585-7.5305 12.082 0.48696 4.1674 0.31631 4.7097-1.6477 5.2364-3.0859 0.82753-3.3021 0.78827-4.6584-0.84595z" />
    </g>
  </LogoStyle>
);

export const LogoStyle = styled.svg`
  fill: rgb(115, 126, 255);
  width: 1.5em;
`;



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Layout.js